import './style.css';
import * as Sentry from '@sentry/vue';
import { createHead } from '@unhead/vue/client';
import hasOwn from 'object.hasown';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createGtag } from 'vue-gtag';
import { setupMetaPixel } from './analytics/metaPixel';
import App from './App.vue';
import { ENVIRONMENT, GOOGLE_GTAG, META_PIXEL_ID } from './config';
import router from './router';

if (!Object.hasOwn) {
  hasOwn.shim();
}

const app = createApp(App);
const head = createHead();

Sentry.init({
  app,
  dsn: 'https://24193bfa46240d12b193a49139861964@o4505475530358784.ingest.us.sentry.io/4510277395349504',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['layup/website'],
      behaviour: 'drop-error-if-contains-third-party-frames',
    }),
  ],
  tracesSampleRate: 0.05,
  enabled: ENVIRONMENT === 'production',
  tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.5,
  ignoreErrors: [
    `undefined is not an object (evaluating 'window.webkit.messageHandlers')`, // An issue with Sentry in iOS Facebook browser - https://github.com/getsentry/sentry-javascript/issues/3040
    `undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')`,
    'Java object is gone',
    "reading 'domInteractive'",
  ],
});

// Google Analytics - Only in Production
if (ENVIRONMENT === 'production') {
  const gtag = createGtag({
    tagId: GOOGLE_GTAG,
  });
  app.use(gtag);
}

app.use(head);
app.use(createPinia());
app.use(router);

if (ENVIRONMENT === 'production') {
  setupMetaPixel(router, META_PIXEL_ID);
}

app.mount('#app');
